<template>
  <div id="app">
    <router-view />
    <div v-if="!$store.getters.hasErr">
      <van-tabbar v-model="active" safe-area-inset-bottom fixed replace="true">
        <van-tabbar-item name="home" icon="wap-home" to="/home">首页</van-tabbar-item>
        <!-- <van-tabbar-item name="service" icon="service" to="/service">服务</van-tabbar-item> -->
        <van-tabbar-item name="financial-report-index" icon="manager" to="/financial-report">财务报告</van-tabbar-item>
        <van-tabbar-item name="Mine" icon="manager" to="/mine">我</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout',
  data() {
    return {
      active: 'home'
    }
  },
  watch:{
    $route:{
      handler:function(){
          this.active =  this.$route.name
      },
      deep:true,
      immediate:true
    }
  },

}
</script>

<style>
/*#app {*/
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/layout.vue